import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      <div className="footer__content">
        {/* <img src={logo} alt="logo" /> */}
        <span className="footer__span">2020 © Penjualan.ID</span>
        <span className="footer__span">Email: contact@jualan.id</span>
      </div>
    </div>
  );
}

export default Footer;
